import type { PlayerType } from '@/types/dtos/player/response/player.dto';

export type DeviceControlSet = {
  camera: boolean;
  microphone: boolean;
  audioOutput: boolean;
  pointer: boolean;
};

export function deviceControlsForPlayer(
  type: PlayerType,
  playerId: string,
  videoPlayerId: string | null | undefined,
  audioPlayerId: string | null | undefined,
  audienceCameraPlayerId?: string | null,
): DeviceControlSet {
  const sendsAudienceCamera = audienceCameraPlayerId != null && playerId === audienceCameraPlayerId;
  if (type === 'confidencePlayer') {
    return { camera: sendsAudienceCamera, microphone: false, audioOutput: false, pointer: true };
  }
  if (type === 'houseCamPlayer') {
    return { camera: sendsAudienceCamera, microphone: false, audioOutput: false, pointer: false };
  }
  if (type === 'screenPublisher') {
    return { camera: false, microphone: false, audioOutput: true, pointer: true };
  }
  if (type === 'stagePlayer' || type === 'roomPlayer' || type === 'onlinePlayer') {
    return {
      camera: playerId === videoPlayerId,
      microphone: playerId === audioPlayerId,
      audioOutput: true,
      pointer: true,
    };
  }
  return { camera: false, microphone: false, audioOutput: false, pointer: false };
}

export function deviceControlsVisible(controls: DeviceControlSet): boolean {
  return controls.camera || controls.microphone || controls.audioOutput || controls.pointer;
}
